import { spSettingsRolesCopyConfirmationLocs } from './role-copy-confirmation/role-copy-confirmation.locs';
import { spSettingsRolesCreateLocs } from './role-create/role-create.locs';
import { spSettingsRolesDeleteConfirmationLocs } from './role-delete-confirmation/role-delete-confirmation.locs';
import { spSettingsRolesRenameDialogLocs } from './role-details/role-details.locs';
import { spSettingsRolesEditLocs } from './role-edit/role-edit.locs';
import { spSettingsRolesPermissionsTableLocs } from './role-table/role-table.locs';
import { spSettingsRolesCardLocs } from './roles-card/roles-card.locs';

export const spRolesModuleLocs = {
	...spSettingsRolesCardLocs,
	...spSettingsRolesRenameDialogLocs,
	...spSettingsRolesEditLocs,
	...spSettingsRolesDeleteConfirmationLocs,
	...spSettingsRolesCopyConfirmationLocs,
	...spSettingsRolesCreateLocs,
	...spSettingsRolesPermissionsTableLocs,
};
